import { ShortList } from '@/components/CategorySections/ExperienceType';
import { Currency } from '@/contexts/currencyContext';
import { Experience, ExperienceTranslation } from '@/services/experienceTypes';

export const toggleExperienceShortlist = (
  exp: Experience,
  lang: string,
  favourites: ShortList[],
  setFavourites: (data: ShortList[]) => void,
  inShortList: boolean,
  currency: Currency,
) => {
  const translation = exp.experienceTranslation.find((item) => {
    if (item.locale === lang) {
      return item;
    }
  }) as ExperienceTranslation;

  const titleSlugs = exp.experienceTranslation.map((item) => ({
    [item.locale]: item.slug,
    title: item.title,
  }));

  const experienceMedia = exp.media[0].mediaFilters?.find(
    (img) => img.name === 'medium_3-2',
  )?.url;

  let firstPrice = null;

  exp.optionMaps.some((option) => {
    const price = option.prices.find((price) => price.price);
    if (price) {
      firstPrice = price.price;
      return true;
    }
  });

  const shortListInfos: ShortList = {
    id: exp.id,
    title: translation.title,
    titleSlugs: titleSlugs,
    categoryId: exp.macroCategory.id,
    media: experienceMedia ? experienceMedia : '',
    zone: {
      code: exp.zone ? exp.zone.code : '',
    },
    price: Number(firstPrice),
    currency: currency.value,
    city: exp.city,
    duration: exp.duration,
    languagens: exp.languages,
    minGuests: exp.minParticipants,
    maxGuests: exp.maxParticipants,
  };

  if (inShortList) {
    const updatedFavourites = favourites.filter((item) => item.id !== exp.id);
    setFavourites(updatedFavourites);
    localStorage.setItem('experience', JSON.stringify(updatedFavourites));
  } else {
    const updatedFavourites = [...favourites, shortListInfos];
    setFavourites(updatedFavourites);
    localStorage.setItem('experience', JSON.stringify(updatedFavourites));
  }
};
